// Emojis do seletor da caixa de escrever. Lista fixa e local de propósito: sem
// dependência nova e sem buscar nada na rede. Os mais usados no atendimento
// ficam primeiro.

export const GRUPOS_EMOJI: Array<{ nome: string; emojis: string[] }> = [
  {
    nome: 'Mais usados',
    emojis: ['😊', '👍', '🙏', '😉', '😄', '✅', '👏', '🤝', '💚', '⚡', '☀️', '💰', '📄', '📲', '🎉', '😅'],
  },
  {
    nome: 'Rostos',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩',
      '😘', '😗', '😚', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐',
      '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔', '😪', '😴', '😷', '🤒', '🤕', '🤢', '🥵', '🥶',
      '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '😕', '😟', '🙁', '😮', '😯', '😲', '😳', '🥺', '😦',
      '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱', '😤', '😡',
    ],
  },
  {
    nome: 'Gestos',
    emojis: ['👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪', '✍️'],
  },
  {
    nome: 'Corações',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝'],
  },
  {
    nome: 'Objetos e símbolos',
    emojis: [
      '☀️', '🌞', '⚡', '🔋', '🔌', '💡', '🏠', '🏢', '🏭', '🌱', '🌿', '♻️', '💰', '💵', '💳', '🧾',
      '📄', '📃', '📑', '📊', '📈', '📉', '🗓️', '📅', '⏰', '⌛', '📲', '📞', '✉️', '📍', '🔑', '🔒',
      '✅', '☑️', '✔️', '❌', '⚠️', '❗', '❓', '💯', '🆗', '🔝', '⭐', '🌟', '✨', '🎉', '🎁', '🏆',
    ],
  },
];
